import { apiClient } from '../api';
import { Path } from '../api/backendUrl';

export interface GoogleCalendarStatus {
  isConnected: boolean;
  email: string | null;
  lastSyncedAt: string | null;
}

const base = import.meta.env.VITE_APP_BACKEND_SERVICE;

export const googleCalendarService = {
  getAuthUrl: async (): Promise<{ authUrl: string }> => {
    const res = await apiClient.get(`${base}/${Path.googleCalendarAuth}`);
    return res.data;
  },

  getStatus: async (): Promise<GoogleCalendarStatus> => {
    const res = await apiClient.get(`${base}/${Path.googleCalendarStatus}`);
    return res.data;
  },

  disconnect: async (): Promise<void> => {
    await apiClient.delete(`${base}/${Path.googleCalendarDisconnect}`);
  },

  syncBookings: async (): Promise<{ synced: number }> => {
    // set a longer timeout for potentially long-running sync requests
    const res = await apiClient.post(
      `${base}/${Path.googleCalendarSync}`,
      {},
      {
        timeout: 60000,
      }
    );
    return res.data;
  },
};

export default googleCalendarService;
